var angular=window.angular,ngModule;
try {ngModule=angular.module(["doxy.templates"])}
catch(e){ngModule=angular.module("doxy.templates",[])}
var v1="<patient-modal room=\"room\" room-admin-can-use-paid-features=\"roomAdminCanUsePaidFeatures\" current-institution=\"currentInstitution\"></patient-modal>\n";
var id1="/app/patient/modal/patient.modal.ngtemplate.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;